import _isEmpty from 'lodash/isEmpty';

export function shouldShowSizeInput(value = '') {
  if (_isEmpty(value)) {
    return true;
  }

  if (!value.endsWith('px')) {
    return false;
  }

  const numericPart = value.slice(0, -2);

  const integerRegex = /^-?\d+$/;
  return integerRegex.test(numericPart);
}
